(() => {
  const init = () => {
    document.querySelectorAll('[data-wt-hk-scroll]').forEach((link) => {
      if (link.dataset.wtHkBound === 'true') return;
      link.dataset.wtHkBound = 'true';

      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    document.querySelectorAll('[data-wt-hk-sticky]').forEach((sticky) => {
      if (sticky.dataset.wtHkBound === 'true') return;
      sticky.dataset.wtHkBound = 'true';

      const target = document.querySelector('#wt-hk-products');

      const update = () => {
        const pastHero = window.scrollY > 520;
        let productsVisible = false;

        if (target) {
          const rect = target.getBoundingClientRect();
          productsVisible = rect.top < window.innerHeight * .78 && rect.bottom > 110;
        }

        sticky.classList.toggle('is-visible', pastHero && !productsVisible);
      };

      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();